module.exports = __webpack_public_path__ + "static/media/group--high-heat.90dbfdfc.svg";